// import BellevueBio from "../../../files/Clinic_Dir_Bio_Erdemar_Tayag_Bellevue_040520.pdf";
import NormanPhoto from "../../../photos/Headshots/Norman Fabula.jpg";
import TacomaBio from "../../../files/Clinic_Dir_Bio_Jesse_Pooler_Tacoma_05292025.pdf";
import BellevueBio from "../../../files/Clinic_Dir_Bio_Sarah_Lund_Bellevue_05292025.pdf";
import LakewoodBio from "../../../files/Clinic_Dir_Bio_Jackie_Schultz_Lakewood_05292025.pdf";
import FederalWayBio from "../../../files/Clinic_Dir_Bio_Norman_Fabula_Tacoma_061621.pdf";
import JoeyHeadshot from "../../../photos/Headshots/Joey Jove.jpg";
import OlympiaBio from "../../../files/Clinic_Dir_Bio_Joey_Jove_Olympia_040620.pdf";
import KristinaPhoto from "../../../photos/Headshots/Kristina Bondar.jpg";

class DirectorData {
  constructor(
    directorName,
    directorTitle,
    profession,
    directorEmail,
    directorCell,
    directorPhoto
  ) {
    this.directorName = directorName;
    this.directorTitle = directorTitle;
    this.profession = profession;
    this.directorEmail = directorEmail;
    this.directorCell = directorCell;
    this.directorPhoto = directorPhoto;
  }
}

class BiographyData {
  constructor(
    biographyText1,
    biographyText2,
    biographyText3,
    biographyFile,
    biographyLink
  ) {
    this.biographyText1 = biographyText1;
    this.biographyText2 = biographyText2;
    this.biographyText3 = biographyText3;
    this.biographyFile = biographyFile;
    this.biographyLink = biographyLink;
  }
}
class LocationData {
  constructor(googleMapsLink, address, officeEmail, officePhone, fax) {
    this.googleMapsLink = googleMapsLink;
    this.address = address;
    this.officeEmail = officeEmail;
    this.officePhone = officePhone;
    this.fax = fax;
  }
}

const TacomaData = {
  directorData: new DirectorData(
    "Jesse Pooler, PT",
    "Physical Therapist",
    "Tacoma Clinic Director",
    null,
    "206-384-2458",
    null
  ),
  biographyData: new BiographyData(
    `Jesse Pooler has been a physical therapist for 23 years but working in all aspects of the profession for close to 30. Jesse grew up in northern Maine and received training at the University of New England. Shortly after college, Jesse moved to the Pacific Northwest and has lived in Tacoma the last 20 years.`,
    null,
    null,
    TacomaBio,
    null
  ),
  locationData: new LocationData(
    "https://goo.gl/maps/QJ9Wt2kCiPPx7NNK8",
    "5006 Center St, Tacoma, WA 98409",
    "epictacoma@epic-pt.com",
    "(253) 476-3333",
    "(253) 476-3334"
  ),
};

const BellevueData = {
  directorData: new DirectorData(
    "Sarah Lund, PT, DPT",
    "Physical Therapist",
    "Bellevue Clinic Director",
    null,
    null,
    null
  ),
  biographyData: new BiographyData(
    `Sarah Lund is the Clinic Director of Bellevue EPIC Physical Therapy. Sarah has recently moved to Washington after over 5 years as a Traveling Physical Therapist. While Sarah obtained their Doctorate of Physical Therapy in Minnesota where they grew up, Sarah has worked across 11 states in their time as a Physical Therapist. Sarah is so excited for this next chapter of putting down roots here and building stronger local connections.`,
    null,
    null,
    BellevueBio,
    null
  ),
  locationData: new LocationData(
    "https://goo.gl/maps/4JZpCiBoFiJTEDbU6",
    "13353 Bel-Red Rd, Bellevue, WA 98005",
    "epicbellevue@epic-pt.com",
    "(425) 679-5996",
    "(425) 968-7590"
  ),
};

const FederalWayData = {
  directorData: new DirectorData(
    "Norman Fabula, MPT",
    "Physical Therapist",
    "Federal Way Clinic Director",
    "normanf@epic-pt.com",
    null,
    NormanPhoto
  ),
  biographyData: new BiographyData(
    `Norman is from the Philippines and has been practicing as a Physical Therapist in the US for 15-years. He worked primarily in outpatient orthopedics of very diverse populations. He enjoys working with all types of injuries, but specializes in the evaluation and treatment of the neck and back, as well as ribs and sacroiliac joint dysfunctions. Norman's expertise is in using a holistic approach when evaluating and treating patients, with an emphasis on manual therapy techniques such as muscle energy, myofascial release, low amplitude mobilizations, and Strain-Counter-strain techniques.`,
    `Norman has pursued extensive continuing education in order to provide clients with advanced therapy techniques. He is a Certified Orthopedic Manual Therapist (COMT), Orthopedic Movement Specialist (OMS), and is currently pursuing his certification as a Strain-Counter-Strain Specialist through the Jones Intsitute.`,
    null,
    FederalWayBio,
    null
  ),
  locationData: new LocationData(
    "https://goo.gl/maps/AZNU6GhSC6AfK4UHA",
    "728 S 320th St Suite G, Federal Way, WA 98003",
    "epicfw@epic-pt.com",
    "(206) 212-6352",
    "(206) 249-8086"
  ),
};

const LakewoodData = {
  directorData: new DirectorData(
    "Jackie Schultz",
    "Physical Therapist",
    "Lakewood Clinic Director",
    null,
    null,
    null
  ),
  biographyData: new BiographyData(
    `Jackie Schultz is a Washington state native growing up in Eastern Washington. She moved to the Puget Sound area to attend PT school at the University of Washington. After graduating from the University of Washington magna cum laude she remained in the Puget Sound area working primarily in outpatient orthopedics. Additionally, she has had the opportunity to work with the geriatric population in skilled nursing facilities, as well as in the home health environment.`,
    null,
    null,
    LakewoodBio,
    null
  ),
  locationData: new LocationData(
    "https://goo.gl/maps/qWQ4QGLch3TMdwGy8",
    "8511 S Tacoma Way Ste #303, Lakewood, WA 98499",
    "epiclakewood@epic-pt.com",
    "(253) 426-1244",
    "(253) 503-7565"
  ),
};

const OlympiaData = {
  directorData: new DirectorData(
    "Joey Jove, PT",
    "Physical Therapist",
    "Olympia Clinic Director",
    "joeyj@epic-pt.com",
    null,
    JoeyHeadshot
  ),
  biographyData: new BiographyData(
    "Joey Jove is originally from Philippines and moved as a young child to California. After joining the army, he pursued his education where he studied and earned his Master’s in physical therapy from Loma Linda. Joey has been practicing as a physical therapist since 1997. He has worked in a variety of physical therapy settings such as outpatient and hospital outpatient.",
    "Joey is a graduate of Loma Linda University’s Physical Therapy program. He has extensive training in Functional Movement, Selective Functional Movement Screen, and is currently pursuing his certification as an Orthopedic Certified Specialist (OCS). He’s married with 2 young beautiful daughters and devotes his time being the best husband and father. Joey also has 20 years of martial arts training in several forms to include Thai boxing, Filipino martial arts, Kenpo karate, Kali, and Silat.",
    null,
    OlympiaBio,
    "https://86f49143-3b30-4a41-953b-7f6665121f99.filesusr.com/ugd/bac57f_012c7af880404f2aa1fc13b8daf74177.pdf"
  ),
  locationData: new LocationData(
    "https://goo.gl/maps/24T4BsVmo19WSbX4A",
    "3000 Limited Ln NW #100, Olympia, WA 98502",
    "epicoly@epic-pt.com",
    "(360) 292-7245",
    "(360) 292-7247"
  ),
};

const PuyallupData = {
  directorData: new DirectorData(
    "Joey Jove, PT",
    "Physical Therapist",
    "Puyallup Clinic Director",
    "joeyj@epic-pt.com",
    null,
    JoeyHeadshot
  ),
  biographyData: new BiographyData(
    "Joey Jove is originally from Philippines and moved as a young child to California. After joining the army, he pursued his education where he studied and earned his Master’s in physical therapy from Loma Linda. Joey has been practicing as a physical therapist since 1997. He has worked in a variety of physical therapy settings such as outpatient and hospital outpatient.",
    "Joey is a graduate of Loma Linda University’s Physical Therapy program. He has extensive training in Functional Movement, Selective Functional Movement Screen, and is currently pursuing his certification as an Orthopedic Certified Specialist (OCS). He’s married with 2 young beautiful daughters and devotes his time being the best husband and father. Joey also has 20 years of martial arts training in several forms to include Thai boxing, Filipino martial arts, Kenpo karate, Kali, and Silat.",
    null,
    OlympiaBio,
    "https://86f49143-3b30-4a41-953b-7f6665121f99.filesusr.com/ugd/bac57f_012c7af880404f2aa1fc13b8daf74177.pdf"
  ),
  locationData: new LocationData(
    "https://goo.gl/maps/TqbTX9zwpgXoGF5t9",
    "16515 Meridian Ave E Ste 202B, Puyallup, WA 98375",
    "epicpuyallup@epic-pt.com",
    "(253) 466-3178",
    "(253) 466-3886"
  ),
};

const SumnerData = {
  directorData: new DirectorData(
    "Kristina Bondar, DPT, PTA",
    "Physical Therapist",
    "Sumner Clinic Director",
    "kbondar.epicpt@gmail.com",
    null,
    KristinaPhoto
  ),
  biographyData: new BiographyData(
    "Kristina is originally from Russia but emigrated to the US as a child. She practiced as a physical therapist assistant for several years before deciding to pursue becoming a Doctor of Physical Therapy.",
    "She graduated from the University of St. Augustine in San Marcos, Ca with high honors. Her approach for every patient is methodical with a focus on finding the root cause. She uses the latest evidence, exercises, and techniques to get her patients back on their feet and doing what they love. She sees a wide variety of orthopedic injuries.",
    "She is married and has three beautiful daughters. She enjoys family time, working out and weightlifting, doing escape rooms with hubby, and traveling to see new places.",
    null,
    null
  ),
  locationData: new LocationData(
    "https://goo.gl/maps/MMWWXn1gA1hisiFD7",
    "5814 Graham Ave #101, Sumner, WA 98390",
    "epicsumner@epic-pt.com",
    "(253) 891-7093",
    "(253) 891-1033"
  ),
};

export {
  TacomaData,
  BellevueData,
  FederalWayData,
  LakewoodData,
  OlympiaData,
  PuyallupData,
  SumnerData,
};
